// @services/payments/adapters/SquareSdkAdapter.ts
import type { SquarePublicPaymentConfig } from "@services/payments/loadPublicPaymentConfig";
import * as Option from "@utils/Option";
import type { OptionTs } from "@ps-bridge/interop";
import { ok, type Ok } from "@ps-bridge/ok";

let squareConfigCache: OptionTs<SquarePublicPaymentConfig> = Option.none();
let squareSdkLoaded = false;

export const SquareSdkAdapter = {
  async load(config: SquarePublicPaymentConfig): Promise<Ok> {
    squareConfigCache = Option.some(config);
    squareSdkLoaded = true;
    return ok;
  },
  getState() {
    return { isLoaded: squareSdkLoaded, config: squareConfigCache };
  },
};

export const getSquareSdkState = () => ({
  isLoaded: squareSdkLoaded,
  config: squareConfigCache,
});
